import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectJob } from '../../../../actions';
import shareIcon from '../../../../images/share-icon-blue.svg';
import InviteFavorites from '../../../InviteFavorites';

export const SendToFavorites = ({ item }) => {
  const dispatch = useDispatch();
  const [showInviteFavoritesPopup, setShowInviteFavoritesPopup] = useState(false);

  const sendToFavorites = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(selectJob(item));
    setShowInviteFavoritesPopup(true);
  };

  return (
    <td
      style={{
        textAlign: 'center',
      }}
    >
      <img
        onClick={sendToFavorites}
        src={shareIcon}
        style={{
          cursor: 'pointer',
          objectFit: 'contain',
        }}
        alt="share_icon"
      />

      {showInviteFavoritesPopup && (
        <div
          style={{
            cursor: 'default',
          }}
          onClick={(event) => event.stopPropagation()}
        >
          <InviteFavorites setShowInviteFavoritesPopup={setShowInviteFavoritesPopup} />
        </div>
      )}
    </td>
  );
};
